// extracted by mini-css-extract-plugin
module.exports = {"toolDetailsContainer":"toolDetails_toolDetailsContainer__197ed"};